import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../../../useApiMutation';
import useMessage from '../../../../useMessage';
import keys from './keys';

const useCreateMarketplaceProfile = () => {
  const { message } = useMessage();
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId }) => `/shows/${showId}/marketplace/profiles`,
    method: 'POST',
    onSuccess: (data) => {
      queryClient.invalidateQueries(keys.showProfiles({ showId: data.showId }));
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while creating marketplace profile." />
        ),
      });
    },
  });

  return {
    createShowProfile: mutation.mutate,
    isCreateShowProfileLoading: mutation.isLoading,
    isCreateShowProfileError: mutation.isError,
    isCreateShowProfileSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useCreateMarketplaceProfile;
